import { PageListCachedDataSource } from './BaseDataSources';
import { IOrganization } from '../Interfaces';

export class ServiceVendorSource extends PageListCachedDataSource<IOrganization> {
  public constructor() {
    super('/datasource/servicevendors');
  }
}